import React from 'react';

/**
 * Email gate screen shown before Spotify auth.
 *
 * The user enters their Spotify email so the app can resolve which
 * Spotify Developer app (client_id / secret) to authenticate against.
 */
export default function EmailGate({
  userEmail,
  onEmailChange,
  onSubmit,
  loading,
  notRegistered,
}) {
  return (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      minHeight: '80vh',
      gap: '20px',
    }}>
      <div style={{
        backgroundColor: '#282828',
        borderRadius: '12px',
        padding: '40px',
        maxWidth: '400px',
        width: '90%',
        textAlign: 'center',
      }}>
        <h2 style={{ marginBottom: '8px', fontSize: '24px' }}>
          Welcome to SnapBeats DJ
        </h2>
        <p style={{ color: '#b3b3b3', marginBottom: '24px', fontSize: '14px' }}>
          Enter your Spotify email to get started
        </p>

        {notRegistered && (
          <div style={{
            backgroundColor: '#3d1f1f',
            border: '1px solid #ef4444',
            borderRadius: '8px',
            padding: '12px',
            marginBottom: '16px',
            fontSize: '13px',
            color: '#fca5a5',
          }}>
            Your account is not registered. Contact the administrator.
          </div>
        )}

        <form
          onSubmit={(e) => {
            e.preventDefault();
            if (userEmail.trim()) onSubmit(userEmail.trim());
          }}
          style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}
        >
          <input
            type="email"
            autoComplete="email"
            placeholder="your@spotify-email.com"
            value={userEmail}
            onChange={(e) => onEmailChange(e.target.value)}
            style={{
              padding: '12px 16px',
              borderRadius: '8px',
              border: '1px solid #444',
              backgroundColor: '#1a1a1a',
              color: 'white',
              fontSize: '16px',
              outline: 'none',
            }}
          />
          <button
            type="submit"
            disabled={loading || !userEmail.trim()}
            style={{
              padding: '12px 24px',
              borderRadius: '8px',
              border: 'none',
              backgroundColor: loading ? '#444' : '#1db954',
              color: 'white',
              fontSize: '16px',
              fontWeight: '600',
              cursor: loading ? 'wait' : 'pointer',
              transition: 'background 0.2s',
            }}
          >
            {loading ? 'Verifying...' : 'Continue'}
          </button>
        </form>
      </div>
    </div>
  );
}
